export const initialState: FormState = {
  fiscalCode: {
    value: "",
    error: null
  },
  IPA: {
    value: "",
    error: null
  },
  admin: {
    value: "",
    error: null
  },
  administrationId: {
    value: "",
    error: null
  },
  email: {
    value: "",
    error: null
  },
  name: {
    value: "",
    error: null
  },
  surname: {
    value: "",
    error: null
  },
  attachment: {
    error: null,
    value: ""
  },
  attachment_mimetype: {
    error: null,
    value: ""
  },
  phone: {
    error: null,
    value: ""
  },
  phoneNumber: {
    error: null,
    value: ""
  },
  role: {
    error: null,
    value: ""
  },
  privacyPolicy: {
    error: null,
    value: ""
  },

}

const formReducer = (state: FormState, action: FormActions): FormState => {

  switch (action.type) {
    case "ADMIN":
      return { ...state, admin: { ...action.payload.admin }, administrationId: { ...action.payload.administrationId }, IPA: { ...action.payload.IPA } }
    case "IPA":
      return { ...state, admin: { ...action.payload.admin }, administrationId: { ...action.payload.administrationId }, IPA: { ...action.payload.IPA } }
    case "CF":
      return { ...state, fiscalCode: { ...action.payload } }
    case "EMAIL":
      return { ...state, email: { ...action.payload } }
    case "NAME":
      return { ...state, name: { ...action.payload } }
    case "SURNAME":
      return { ...state, surname: { ...action.payload } }
    case "FILE":
      return { ...state, attachment: { ...action.payload } }
    case "FILE_MIMETYPE":
      return { ...state, attachment_mimetype: { ...action.payload } }
    case "PHONENUMBER":
      return { ...state, phoneNumber: { ...action.payload } }
    case "PHONE":
      return { ...state, phone: { ...action.payload } }
    case "ROLE":
      return { ...state, role: { ...action.payload } }
    case "PRIVACYPOLICY":
      return { ...state, privacyPolicy: { ...action.payload } }
    default:
      return state;
  }

}

export default formReducer;